import { EventData } from '../models'

export const eventFormatter = (eventData: EventData): object => {
  const data = {
    ...eventData,
    ...eventData.data
  }
  if (eventData.data) {
    delete data.data
  }
  return data
}
